import { createSlice } from '@reduxjs/toolkit';

const controlSlice = createSlice({
	name: 'control',
	initialState: { loading: false, error: null },
	reducers: {
		triggerSync: (state) => {
			state.loading = true;
		},
		triggerSyncSuccess: (state) => {
			state.loading = false;
		},
		triggerSyncError: (state, action) => {
			state.loading = false;
			state.error = action.payload;
		}
	}
});

export const controlActions = controlSlice.actions;
export default controlSlice.reducer;
